const mockInstances = [
  {
    id: 'mock-instance-001',
    name: 'CSC Development Instance',
    status: 'ACTIVE',
    region: 'us-east-1',
  },
  {
    id: 'mock-instance-002',
    name: 'CSC Test Instance',
    status: 'ACTIVE',
    region: 'us-east-1',
  },
  {
    id: 'mock-instance-003',
    name: 'CSC Inactive Instance',
    status: 'INACTIVE',
    region: 'us-east-1',
  },
];

const mockAgentsByInstance = {
  'mock-instance-001': [
    {
      id: '11111111-1111-4111-8111-111111111111',
      arn: 'arn:aws:connect:us-east-1:123456789012:instance/mock-instance-001/agent/11111111-1111-4111-8111-111111111111',
      username: 'jane.doe',
      last_modified_time: '2026-08-14T12:00:00+00:00',
      last_modified_region: 'us-east-1',
      directory_user_id: 'directory-jane-doe',
      hierarchy_group_id: 'hierarchy-agents',
      routing_profile_id: 'rp-routing-standard',
      security_profile_ids: ['security-agent'],
      tags: { team: 'CSC' },
      identity: {
        first_name: 'Jane',
        last_name: 'Doe',
        email: 'jane.doe@example.com',
        mobile: '+15555550101',
        secondary_email: null,
      },
      phone_config: {
        phone_type: 'SOFT_PHONE',
        auto_accept: false,
        after_contact_work_time_limit: 30,
        desk_phone_number: null,
      },
    },
    {
      id: '22222222-2222-4222-8222-222222222222',
      arn: 'arn:aws:connect:us-east-1:123456789012:instance/mock-instance-001/agent/22222222-2222-4222-8222-222222222222',
      username: 'john.smith',
      last_modified_time: '2026-08-13T21:30:00+00:00',
      last_modified_region: 'us-east-1',
      directory_user_id: 'directory-john-smith',
      hierarchy_group_id: 'hierarchy-supervisors',
      routing_profile_id: 'rp-routing-escalations',
      security_profile_ids: ['security-supervisor'],
      tags: { team: 'CSC' },
      identity: {
        first_name: 'John',
        last_name: 'Smith',
        email: 'john.smith@example.com',
        mobile: '+15555550102',
        secondary_email: null,
      },
      phone_config: {
        phone_type: 'SOFT_PHONE',
        auto_accept: true,
        after_contact_work_time_limit: 60,
        desk_phone_number: null,
      },
    },
  ],
  'mock-instance-002': [
    {
      id: '33333333-3333-4333-8333-333333333333',
      arn: 'arn:aws:connect:us-east-1:123456789012:instance/mock-instance-002/agent/33333333-3333-4333-8333-333333333333',
      username: 'alex.johnson',
      last_modified_time: '2026-08-12T09:15:00+00:00',
      last_modified_region: 'us-east-1',
      directory_user_id: 'directory-alex-johnson',
      hierarchy_group_id: 'hierarchy-agents',
      routing_profile_id: 'rp-routing-standard',
      security_profile_ids: ['security-agent'],
      tags: { team: 'CSC' },
      identity: {
        first_name: 'Alex',
        last_name: 'Johnson',
        email: 'alex.johnson@example.com',
        mobile: '+15555550103',
        secondary_email: null,
      },
      phone_config: {
        phone_type: 'SOFT_PHONE',
        auto_accept: false,
        after_contact_work_time_limit: 30,
        desk_phone_number: null,
      },
    },
  ],
  'mock-instance-003': [],
};

const mockSecurityProfilesByInstance = {
  'mock-instance-001': [
    {
      id: 'sp-security-agent',
      name: 'Security Agent',
    },
    {
      id: 'sp-security-supervisor',
      name: 'Security Supervisor',
    },
  ],
  'mock-instance-002': [
    {
      id: 'sp-security-agent',
      name: 'Security Agent',
    },
  ],
  'mock-instance-003': [],
};

const mockRoutingProfilesByInstance = {
  'mock-instance-001': [
    {
      id: 'rp-routing-standard',
      name: 'Routing Standard',
    },
    {
      id: 'rp-routing-escalations',
      name: 'Routing Escalations',
    },
  ],
  'mock-instance-002': [
    {
      id: 'rp-routing-standard',
      name: 'Routing Standard',
    },
  ],
  'mock-instance-003': [],
};

const mockHierarchyGroupIdsByInstance = {
  'mock-instance-001': [
    {
      id: 'hg-hierarchy-agents-1',
      name: 'Agent Group 1',
    },
    {
      id: 'hg-hierarchy-agents-2',
      name: 'Agent Group 2',
    },
    {
      id: 'hg-hierarchy-agents-3',
      name: 'Agent Group 3',
    }
  ],
  'mock-instance-002': [
    {
      id: 'hg-hierarchy-agents-2',
      name: 'Agent Group 2',
    },
  ],
  'mock-instance-003': [],
};

const mockAgentActivityByInstance = {
  'mock-instance-001': [
    {
      username: 'alex.johnson',
      agent_name: 'Alex Johnson',
      number_contacts_handled: 28,
      talk_time: 5630.0,
      hold_time: 410.0,
      after_contact_work: 780.0,
      average_handle_time: 243.57,
      available_time: 7200.0,
    },
     {
      username: 'emily.smith',
      agent_name: 'Emily Smith',
      number_contacts_handled: 18,
      talk_time: 5330.0,
      hold_time: 210.0,
      after_contact_work: 720.0,
      average_handle_time: 143.57,
      available_time: 6200.0,
    },
     {
      username: 'michael.brown',
      agent_name: 'Michael Brown',
      number_contacts_handled: 22,
      talk_time: 5130.0,
      hold_time: 110.0,
      after_contact_work: 380.0,
      average_handle_time: 213.57,
      available_time: 5200.0,
    },
  ],
  'mock-instance-002': [
    {
      username: 'jane.doe',
      agent_name: 'Jane Doe',
      number_contacts_handled: 14,
      talk_time: 2485.0,
      hold_time: 205.0,
      after_contact_work: 390.0,
      average_handle_time: 220.71,
      available_time: 5400.0,
    },
  ],
  'mock-instance-003': [],
};

const mockQueuePerformanceByInstance = {
  'mock-instance-001': [
    {
      queue_id: 'queue-customer-service',
      queue_name: 'Customer Service',
      offered: 142,
      handled: 128,
      abandoned: 14,
      abandoned_rate: 9.86,
      average_wait_time: 42.5,
      max_wait_time: 318.0,
      average_abandoned_time: 76.2,
    },
    {
      queue_id: 'queue-escalations',
      queue_name: 'Escalations',
      offered: 64,
      handled: 61,
      abandoned: 3,
      abandoned_rate: 4.69,
      average_wait_time: 28.1,
      max_wait_time: 205.0,
      average_abandoned_time: 55.7,
    },
  ],
  'mock-instance-002': [
    {
      queue_id: 'queue-test',
      queue_name: 'Test Queue',
      offered: 37,
      handled: 35,
      abandoned: 2,
      abandoned_rate: 5.41,
      average_wait_time: 31.4,
      max_wait_time: 144.0,
      average_abandoned_time: 49.0,
    },
  ],
  'mock-instance-003': [],
};

const mockAttributesByInstance = {
  'mock-instance-001': [
    {
      instanceId: 'mock-instance-001',
      attributeId: 'EMPLOYEE_TYPE',
      attributeName: 'employeeType',
      displayName: 'Employee Type',
      dataType: 'String',
      
      allowedOperators : {
        EQUALS: true,
        NOT_EQUALS: true,
        IN: true,
        NOT_IN: true,
      },
      
      allowedValues: [
        {
          "value": "INTERNAL",
          "displayName": "Internal"
        },
        {
          "value": "EXTERNAL",
          "displayName": "External"
        }
      ],
      "active": true
    },
    {
      instanceId: 'mock-instance-001',
      attributeId: 'LOCATION',
      attributeName: 'location',
      displayName: 'Location',
      dataType: 'String',

      allowedOperators : {
        EQUALS: true,
        NOT_EQUALS: true,
        IN: true,
        NOT_IN: true,
      },

      allowedValues: [
        {
          "value": "ONSHORE",
          "displayName": "Onshore"
        },
        {
          "value": "OFFSHORE",
          "displayName": "Offshore"
        }
      ],
      "active": true
    },
    {
      instanceId: 'mock-instance-001',
      attributeId: 'LANGUAGE',
      attributeName: 'language',
      displayName: 'Language',
      dataType: 'String',

       allowedOperators : {
        EQUALS: true,
        NOT_EQUALS: true,
        IN: true,
        NOT_IN: true,
      },

      allowedValues: [
        {
          "value": "EN",
          "displayName": "English"
        },
        {
          "value": "FR",
          "displayName": "French"
        }
      ],
      "active": true
    },
     {
      instanceId: 'mock-instance-001',
      attributeId: 'CUSTOMER_TYPE',
      attributeName: 'customerType',
      displayName: 'Customer Type',
      dataType: 'String',

       allowedOperators : {
        EQUALS: true,
        NOT_EQUALS: true,
        IN: true,
        NOT_IN: true,
      },

      allowedValues: [
        {
          "value": "PREMIUM",
          "displayName": "Premium"
        },
        {
          "value": "STANDARD",
          "displayName": "Standard"
        }
      ],
      "active": true
    },
     {
      instanceId: 'mock-instance-001',
      attributeId: 'CALL_TYPE',
      attributeName: 'callType',
      displayName: 'Call Type',
      dataType: 'String',

       allowedOperators : {
        EQUALS: true,
        NOT_EQUALS: true,
        IN: true,
        NOT_IN: true,
      },

      allowedValues: [
        {
          "value": "SUPPORT",
          "displayName": "Support"
        },
        {
          "value": "SALES",
          "displayName": "Sales"
        }
      ],
      "active": true
    }
  ],
  'mock-instance-002': [
     {
      instanceId: 'mock-instance-002',
      attributeId: 'EMPLOYEE_TYPE',
      attributeName: 'employeeType',
      displayName: 'Employee Type',
      dataType: 'String',
      
      allowedOperators : {
        EQUALS: true,
        NOT_EQUALS: true,
        IN: true,
        NOT_IN: true,
      },

      allowedValues: [
        {
          "value": "INTERNAL",
          "displayName": "Internal"
        },
        {
          "value": "EXTERNAL",
          "displayName": "External"
        }
      ],
      "active": true
    },
    {
      instanceId: 'mock-instance-002',
      attributeId: 'LOCATION',
      attributeName: 'location',
      displayName: 'Location',
      dataType: 'String',
      
      allowedOperators : {
        EQUALS: true,
        NOT_EQUALS: true,
        IN: true,
        NOT_IN: true,
      },

      allowedValues: [
        {
          "value": "ONSHORE",
          "displayName": "Onshore"
        },
        {
          "value": "OFFSHORE",
          "displayName": "Offshore"
        }
      ],
      "active": true
    }
  ],
  'mock-instance-003': [],
};

const mockQueuesByInstance = {
  'mock-instance-001': [
    { id: 'queue-123', name: 'Customer Service' },
    { id: 'queue-456', name: 'Escalations' },
  ],
  'mock-instance-002': [
    { id: 'queue-789', name: 'Test Customer Service' },
  ],
  'mock-instance-003': [],
};

const mockRoutingGroupsByInstance = {
  'mock-instance-001': [
    {
      instanceId: 'mock-instance-001',
      routingGroupId: 'INTERNAL_ONSHORE',
      displayName: 'Internal Onshore',
      criteria: {
        logic: "AND",
        conditions: [
          {
            attributeId: 'EMPLOYEE_TYPE',
            operator: 'EQUALS',
            value: 'INTERNAL',
            proficiency: 3
          },
          {
            attributeId: 'LOCATION',
            operator: 'EQUALS',
            value: 'ONSHORE',
            proficiency: 3
          },
        ]
      },
      connectQueueId: "queue-123",
      active: true
    },
    {
      instanceId: 'mock-instance-001',
      routingGroupId: 'EXTERNAL_ONSHORE',
      displayName: 'External Onshore',
      criteria: {
        logic: "AND",
        conditions: [
          {
            attributeId: 'EMPLOYEE_TYPE',
            operator: 'EQUALS',
            value: 'EXTERNAL',
            proficiency: 5
          },
          {
            attributeId: 'LOCATION',
            operator: 'EQUALS',
            value: 'ONSHORE',
            proficiency: 5
          },
        ]
      },
      connectQueueId: "queue-123",
      active: true
    },
    {
      instanceId: 'mock-instance-001',
      routingGroupId: 'INTERNAL_OFFSHORE',
      displayName: 'Internal Offshore',
      criteria: {
        logic: "AND",
        conditions: [
          {
            attributeId: 'EMPLOYEE_TYPE',
            operator: 'EQUALS',
            value: 'INTERNAL',
            proficiency: 3
          },
          {
            attributeId: 'LOCATION',
            operator: 'EQUALS',
            value: 'OFFSHORE',
            proficiency: 3
          },
        ]
      },
      connectQueueId: "queue-123",
      active: true
    },
    {
      instanceId: 'mock-instance-001',
      routingGroupId: 'EXTERNAL_OFFSHORE',
      displayName: 'External Offshore',
      criteria: {
        logic: "AND",
        conditions: [
          {
            attributeId: 'EMPLOYEE_TYPE',
            operator: 'EQUALS',
            value: 'EXTERNAL',
            proficiency: 5
          },
          {
            attributeId: 'LOCATION',
            operator: 'EQUALS',
            value: 'OFFSHORE',
            proficiency: 5
          },
        ]
      },
      connectQueueId: "queue-123",
      active: true
    }
  ],
  'mock-instance-002': [{
     instanceId: 'mock-instance-002',
      routingGroupId: 'INTERNAL_ONSHORE',
      displayName: 'Internal Onshore',
      criteria: {
        logic: "AND",
        conditions: [
          {
            attributeId: 'EMPLOYEE_TYPE',
            operator: 'EQUALS',
            value: 'INTERNAL',
            proficiency: 5
          },
          {
            attributeId: 'LOCATION',
            operator: 'EQUALS',
            value: 'ONSHORE',
            proficiency: 5
          },
        ]
      },
      connectQueueId: "queue-123",
      active: true
    },
     {
      instanceId: 'mock-instance-002',
      routingGroupId: 'EXTERNAL_ONSHORE',
      displayName: 'External Onshore',
      criteria: {
        logic: "AND",
        conditions: [
          {
            attributeId: 'EMPLOYEE_TYPE',
            operator: 'EQUALS',
            value: 'EXTERNAL',
            proficiency: 1
          },
          {
            attributeId: 'LOCATION',
            operator: 'EQUALS',
            value: 'ONSHORE',
            proficiency: 1
          },
        ]
      },
      connectQueueId: "queue-123",
      active: true
    }
  ],
  'mock-instance-003': [{
    instanceId: 'mock-instance-003',
    routingGroupId: 'INTERNAL_ONSHORE',
    displayName: 'Internal Onshore',
    criteria: {
      logic: "AND",
      conditions: [
        {
          attributeId: 'EMPLOYEE_TYPE',
          operator: 'EQUALS',
          value: 'INTERNAL',
          proficiency: 3
        },
        {
          logic: "OR",
          conditions: [
            {
              attributeId: 'LOCATION',
              operator: 'EQUALS',
              value: 'ONSHORE',
              proficiency: 3
            },
            {
              attributeId: 'LOCATION',
              operator: 'EQUALS',
              value: 'OFFSHORE',
              proficiency: 3
            }
          ]
        },
      ]
    },
    connectQueueId: "queue-123",
    active: true
  }
  ],
};

const mockRoutingPoliciesByInstance = {
  'mock-instance-001': [
    {
      instanceId: 'mock-instance-001',
      policyId: 'policy-001',
      policyName: 'Internal First',
      version: 1,
      status: 'Active',
      updated: '2024-06-01T12:00:00Z',
      routingSteps: [
        {
          "step": 1,
          "routingGroupId": 'INTERNAL_ONSHORE',
          "timeoutSeconds": 30
        },
        {
          "step": 2,
          "routingGroupId": 'INTERNAL_OFFSHORE',
          "timeoutSeconds": 30
        },
        {
          "step": 3,
          "routingGroupId": 'EXTERNAL_ONSHORE',
          "timeoutSeconds": null
        }
      ]
    },
     {
      instanceId: 'mock-instance-002',
      policyId: 'policy-002',
      policyName: 'Onshore First',
      version: 1,
      status: 'Active',
      updated: '2024-06-01T12:00:00Z',
      routingSteps: [
        {
          "step": 1,
          "routingGroupId": 'INTERNAL_ONSHORE',
          "timeoutSeconds": 30
        },
        {
          "step": 2,
          "routingGroupId": 'EXTERNAL_ONSHORE',
          "timeoutSeconds": 30
        },
        {
          "step": 3,
          "routingGroupId": 'INTERNAL_OFFSHORE',
          "timeoutSeconds": null
        }
      ]
    }
  ],
  'mock-instance-002': [
    {
      instanceId: 'mock-instance-002',
      policyId: 'policy-001',
      policyName: 'Internal First',
      version: 1,
      status: 'Active',
      updated: '2024-06-01T12:00:00Z',
      routingSteps: [
        {
          "step": 1,
          "routingGroupId": 'INTERNAL_ONSHORE',
          "timeoutSeconds": 30
        },
        {
          "step": 2,
          "routingGroupId": 'INTERNAL_OFFSHORE',
          "timeoutSeconds": 30
        },
        {
          "step": 3,
          "routingGroupId": 'EXTERNAL_ONSHORE',
          "timeoutSeconds": null
        }
      ]
    }
  ],
  'mock-instance-003': [ ]
};

const mockRoutingRestrictionByInstance = {
  'mock-instance-001': [
    {
      instanceId: 'mock-instance-001',
      restrictionId: 'restriction-001',
      restrictionName: 'No Offshore Agents',
      description: 'Restriction based on location',
      status: 'Active',
      contactCriteria: {
        logic: "AND",
        conditions: [
          {
            attributeId: 'CUSTOMER_TYPE',
            operator: 'EQUALS',
            value: 'PREMIUM'
          },
          {
            attributeId: 'CALL_TYPE',
            operator: 'EQUALS',
            value: 'SUPPORT'
          }
        ]
      },
      actions: [
        {
          type: 'EXCLUDE_ROUTING_GROUPS',
          routingGroupIds: [
            'INTERNAL_OFFSHORE',
            'EXTERNAL_OFFSHORE'
          ]
        }
      ],

      effectiveTime : {
        startTime: null,
        endTime: '2024-12-31T23:59:59Z',
        timezone: "America/Chicago"
      }
    },
     {
      instanceId: 'mock-instance-002',
      restrictionId: 'restriction-002',
      restrictionName: 'No External Agents',
      description: 'Restriction based on Employement',
      status: 'Active',
      contactCriteria: {
        logic: "AND",
        conditions: [
          {
            attributeId: 'CUSTOMER_TYPE',
            operator: 'EQUALS',
            value: 'STANDARD'
          },
          {
            attributeId: 'CALL_TYPE',
            operator: 'EQUALS',
            value: 'SALES'
          }
        ]
      },
      actions: [
        {
          type: 'EXCLUDE_ROUTING_GROUPS',
          routingGroupIds: [
            'EXTERNAL_ONSHORE',
            'EXTERNAL_OFFSHORE'
          ]
        }
      ],

      effectiveTime : {
        startTime: '2024-01-01T00:00:00Z',
        endTime: '2024-12-31T23:59:59Z',
        timezone: "America/Chicago"
      }
    }
  ],
  'mock-instance-002': [
    {
      instanceId: 'mock-instance-002',
      restrictionId: 'restriction-002',
      restrictionName: 'No External Agents',
      description: 'Restriction based on Employement',
      status: 'Active',
      contactCriteria: {
        logic: "AND",
        conditions: [
          {
            attributeId: 'CUSTOMER_TYPE',
            operator: 'EQUALS',
            value: 'STANDARD'
          },
          {
            attributeId: 'CALL_TYPE',
            operator: 'EQUALS',
            value: 'SALES'
          }
        ]
      },
      actions: [
        {
          type: 'EXCLUDE_ROUTING_GROUPS',
          routingGroupIds: [
            'EXTERNAL_ONSHORE',
            'EXTERNAL_OFFSHORE'
          ]
        }
      ],

      effectiveTime : {
        startTime: '2024-01-01T00:00:00Z',
        endTime: '2024-12-31T23:59:59Z',
        timezone: "America/Chicago"
      }
    }
  ],
  'mock-instance-003': []
};

const mockRoutingSimulationsByInstance = {
  'mock-instance-001': [
      {
        simulationId: 'simulation-001',
        instanceId: 'mock-instance-001',
        simulationName: 'Premium Support',
        routingPolicyId: 'policy-001',
        routingPolicyName: 'Internal First',
        restrictionId: 'restriction-001',
        restrictionName: 'No External Agents',
        contactAttributes: {
          CUSTOMER_TYPE: 'PREMIUM',
          CALL_TYPE: 'SUPPORT'
        }
      },
      {
        simulationId: 'simulation-002',
        instanceId: 'mock-instance-001',
        simulationName: 'Standard Sales',
        routingPolicyId: 'policy-002',
        routingPolicyName: 'Onshore First',
        restrictionId: 'restriction-002',
        restrictionName: 'No External Agents',
        contactAttributes: {
          CUSTOMER_TYPE: 'STANDARD',
          CALL_TYPE: 'SALES'
        }
      }
  ],
  'mock-instance-002': [
    {
        simulationId: 'simulation-001',
        instanceId: 'mock-instance-002',
        simulationName: 'Premium Support',
        routingPolicyId: 'policy-001',
        routingPolicyName: 'Internal First',
        restrictionId: 'restriction-001',
        restrictionName: 'No External Agents',
        contactAttributes: {
          CUSTOMER_TYPE: 'PREMIUM',
          CALL_TYPE: 'SUPPORT'
        }
      },
      {
        simulationId: 'simulation-002',
        instanceId: 'mock-instance-002',
        simulationName: 'Standard Support',
        routingPolicyId: 'policy-002',
        routingPolicyName: 'Onshore First',
        restrictionId: 'restriction-002',
        restrictionName: 'No External Agents',
        contactAttributes: {
          CUSTOMER_TYPE: 'STANDARD',
          CALL_TYPE: 'SALES'
        }
      }
  ],
  'mock-instance-003': []
};

const mockRoutingSimulationResultById = {
'simulation-001': [
    {
      simulationId: 'simulation-001',
      result: 'success',
      contactAttributes : {
        CUSTOMER_TYPE: 'PREMIUM',
        CALL_TYPE: 'SUPPORT'
      },
      baseRoutingPolicy: {
        routingPolicyId: 'policy-001',
      },
      restrictionEvaluation: {
        restrictionId: 'restriction-001',
        contactAttributes: {
          CUSTOMER_TYPE: 'PREMIUM',
          CALL_TYPE: 'SUPPORT'
        },
        action: {
          type: 'EXCLUDE_ROUTING_GROUPS',
          routingGroupIds: [
            'INTERNAL_OFFSHORE',
            'EXTERNAL_OFFSHORE'
          ]
        }
      },
      effectiveRoutingOutcome: {
        routingGroupIds: [
          { 
            step : 1,
            group: 'INTERNAL_ONSHORE',
            timeout: '30 Seconds',
            result: 'ACTIVE'
          },
          {
            step: 2,
            group: 'INTERNAL_OFFSHORE',
            timeout: '30 Seconds',
            result: 'EXCLUDED'
          },
          {
            step: 3,
            group: 'EXTERNAL_ONSHORE',
            timeout: 'Unlimited',
            result: 'ACTIVE'
          }
        ]
      },
      finalRoutingPath: [
        {
          group: 'INTERNAL_ONSHORE',
          timeout: '30 Seconds',
        },
        {
          group: 'EXTERNAL_ONSHORE',
          timeout: 'wait until routed',
        },
      ]
    }
  ],
  'simulation-002': [
    {
      simulationId: 'simulation-002',
      result: 'success',
      contactAttributes : {
        CUSTOMER_TYPE: 'STANDARD',
        CALL_TYPE: 'SALES'
      },
      baseRoutingPolicy: {
        routingPolicyId: 'policy-002',
      },
      restrictionEvaluation: {
        restrictionId: 'restriction-002',
        contactAttributes: {
          CUSTOMER_TYPE: 'STANDARD',
          CALL_TYPE: 'SALES'
        },
        action: {
          type: 'EXCLUDE_ROUTING_GROUPS',
          routingGroupIds: [
            'EXTERNAL_ONSHORE',
            'EXTERNAL_OFFSHORE'
          ]
        }
      },
      effectiveRoutingOutcome: {
        routingGroupIds: [
          { 
            group: 'INTERNAL_ONSHORE',
            timeout: '30 Seconds',
          },
          {
            group: 'INTERNAL_OFFSHORE',
            timeout: 'wait until routed',
          }
        ]
      },
      finalRoutingPath: [
        {
          step: 1,
          group: 'INTERNAL_ONSHORE',
          timeout: '30 Seconds',
          result: 'ACTIVE'
        },
        {
          step: 2,
          group: 'INTERNAL_OFFSHORE',
          timeout: '30 Seconds',
          result: 'EXCLUDED'
        },
        {
          step: 3,
          group: 'EXTERNAL_ONSHORE',
          timeout: '30 Seconds',
          result: 'ACTIVE'
        }
      ]
    }
  ]
};

const mockArchiveDataByInstance = {
    'mock-instance-001': [
    {
      "archiveId": "archive-1789746907734",
      "instanceId": "mock-instance-001",
      "archiveName": "Mock Archive 1",
      "instanceName": "CSC Development Instance",
      "archiveType": "FULL",
      "components": [
        "agents",
        "agentRoutingProfiles",
        "queues",
        "attributes",
        "securityProfiles",
        "hierarchyGroups",
        "prompts",
        "phoneNumbers",
        "quickConnects",
        "contactFlows",
        "hoursOfOperation",
        "flowModules"
      ],
      "date": "2026-09-18T15:55:07.734Z",
      "resourceCounts": [
        {
          component: "agents",
          label: "Agents",
          count: 10
        },
        {
          component: "agentRoutingProfiles",
          label: "Routing Profiles",
          count: 9
        },
        {
          component: "queues",
          label: "Queue",
          count: 2
        },
        {
          component: "attributes",
          label: "Attributes",
          count: 8
        },
        {
          component: "securityProfiles",
          label: "Security Profiles",
          count: 8
        },
        {
          component: "hierarchyGroups",
          label: "Hierarchy Groups",
          count: 1
        },
        {
          component: "prompts",
          label: "Prompts",
          count: 1
        },
        {
          component: "quickConnects",
          label: "Quick Connects",
          count: 1
        },
        {
          component: "contactFlows",
          label: "Contact Flows",
          count: 1
        },
        {
          component: "hoursOfOperation",
          label: "Hours of Operation",
          count: 1
        },
        {
          component: "flowModules",
          label: "Flow Modules",
          count: 1
        },
        {
          component: "phoneNumbers",
          label: "Phone Numbers",
          count: 1
        }
        // {
        //   component: "applicationRoutingPolicies",
        //   label: "Application Routing Policies",
        //   count: 1
        // }
      ],
      "resources": "43", 
      "status": "Complete",
      "document": {
        "archiveId": "archive-1789746907734",
        "instanceId": "mock-instance-001",
        "archiveName": "Mock Archive 1",
        "archiveType": "FULL",
        "components": [
          "agents",
          "agentRoutingProfiles",
          "queues",
          "attributes",
          "securityProfiles",
          "hierarchyGroups",
          "prompts",
          "flowModules",
          "quickConnects",
          "hoursOfOperation",
          "contactFlows",
          "phoneNumbers"
        ],
        "date": "2026-09-18T15:55:07.734Z",
        "resources": {
          "agents": [
            {
              "Id": "agents-1",
              "Username": "mockuser1",
              "IdentityInfo": {
                "FirstName": "Jon",
                "LastName": "Smith"
              },
            },
            {
              "Id": "agents-2",
              "Username": "mockuser2",
              "IdentityInfo": {
                "FirstName": "John",
                "LastName": "Doe"
              },
            },
            {
              "Id": "agents-3",
              "Username": "mockuser3",
              "IdentityInfo": {
                "FirstName": "Mock",
                "LastName": "Agent3"
              }
            },
            {
              "Id": "agents-4",
              "Username": "mockuser4",
              "IdentityInfo": {
                "FirstName": "Mock",
                "LastName": "Agent4"
              }
            },
            {
              "Id": "agents-5",
              "Username": "mockuser5",
              "IdentityInfo": {
                "FirstName": "Mock",
                "LastName": "Agent5"
              }
            },
            {
              "Id": "agents-6",
              "Username": "mockuser6",
              "IdentityInfo": {
                "FirstName": "Mock",
                "LastName": "Agent6"
              }
            },
            {
              "Id": "agents-7",
              "Username": "mockuser7",
              "IdentityInfo": {
                "FirstName": "Mock",
                "LastName": "Agent7"
              }
            },
            {
              "Id": "agents-8",
              "Username": "mockuser8",
              "IdentityInfo": {
                "FirstName": "Mock",
                "LastName": "Agent8"
              }
            },
            {
              "Id": "agents-9",
              "Username": "mockuser9",
              "IdentityInfo": {
                "FirstName": "Mock",
                "LastName": "Agent9"
              }
            },
            {
              "Id": "agents-10",
              "Username": "mockuser10",
              "IdentityInfo": {
                "FirstName": "Mock",
                "LastName": "Agent10"
              }
            }
          ],
          "agentRoutingProfiles": [
            {
              "InstanceId": "agentRoutingProfiles-1",
              "Name": "Mock Routing Profiles 1",
              "MediaConcurrencies": [
                {
                  "Channel": "VOICE",
                  "Concurrency": 1
                },
                {
                  "Channel": "CHAT",
                  "Concurrency": 1
                }
              ]
            },
            {
              "InstanceId": "agentRoutingProfiles-2",
              "Name": "Mock Routing Profiles 2",
              "MediaConcurrencies": [
                {
                  "Channel": "VOICE",
                  "Concurrency": 1
                },
                {
                  "Channel": "CHAT",
                  "Concurrency": 1
                }
              ]
            },
            {
              "InstanceId": "agentRoutingProfiles-3",
              "Name": "Mock Routing Profiles 3",
              "MediaConcurrencies": [
                {
                  "Channel": "VOICE",
                  "Concurrency": 1
                },
                {
                  "Channel": "CHAT",
                  "Concurrency": 1
                }
              ]
            },
            {
              "InstanceId": "agentRoutingProfiles-4",
              "Name": "Mock Routing Profiles 4",
              "MediaConcurrencies": [
                {
                  "Channel": "VOICE",
                  "Concurrency": 1
                },
                {
                  "Channel": "CHAT",
                  "Concurrency": 1
                }
              ]
            },
            {
              "InstanceId": "agentRoutingProfiles-5",
              "Name": "Mock Routing Profiles 5",
              "MediaConcurrencies": [
                {
                  "Channel": "VOICE",
                  "Concurrency": 1
                },
                {
                  "Channel": "CHAT",
                  "Concurrency": 1
                }
              ]
            },
            {
              "InstanceId": "agentRoutingProfiles-6",
              "Name": "Mock Routing Profiles 6",
              "MediaConcurrencies": [
                {
                  "Channel": "VOICE",
                  "Concurrency": 1
                },
                {
                  "Channel": "CHAT",
                  "Concurrency": 1
                }
              ]
            },
            {
              "InstanceId": "agentRoutingProfiles-7",
              "Name": "Mock Routing Profiles 7",
              "MediaConcurrencies": [
                {
                  "Channel": "VOICE",
                  "Concurrency": 1
                },
                {
                  "Channel": "CHAT",
                  "Concurrency": 1
                }
              ]
            },
            {
              "InstanceId": "agentRoutingProfiles-8",
              "Name": "Mock Routing Profiles 8",
              "MediaConcurrencies": [
                {
                  "Channel": "VOICE",
                  "Concurrency": 1
                },
                {
                  "Channel": "CHAT",
                  "Concurrency": 1
                }
              ]
            },
            {
              "InstanceId": "agentRoutingProfiles-9",
              "Name": "Mock Routing Profiles 9",
              "MediaConcurrencies": [
                {
                  "Channel": "VOICE",
                  "Concurrency": 1
                },
                {
                  "Channel": "CHAT",
                  "Concurrency": 1
                }
              ]
            }
          ],
          "queues": [
            {
              "QueueId": "queues-1",
              "Name": "Mock Queue 1",
              "Status": "ENABLED"
            },
            {
              "QueueId": "queues-2",
              "Name": "Mock Queue 2",
              "Status": "ENABLED"
            }
          ],
          "attributes": [
            {
              "Name": "Mock Attributes 1",
              "Values": {
                "StringList": ["Value1", "Value2"]
              }
            },
            {
              "Name": "Mock Attributes 2",
              "Values": {
                "StringList": ["Value3", "Value4"]
              }
            },
            {
              "Name": "Mock Attributes 3",
              "Values": {
                "StringList": ["Value5", "Value6"]
              }
            },
            {
              "Name": "Mock Attributes 4",
              "Values": {
                "StringList": ["Value7", "Value8"]
              }
            },
            {
              "Name": "Mock Attributes 5",
              "Values": {
                "StringList": ["Value9", "Value10"]
              }
            },
            {
              "Name": "Mock Attributes 6",
              "Values": {
                "StringList": ["Value11", "Value12"]
              }
            },
            {
              "Name": "Mock Attributes 7",
              "Values": {
                "StringList": ["Value13", "Value14"]
              }
            },
            {
              "Name": "Mock Attributes 8",
              "Values": {
                "StringList": ["Value15", "Value16"]
              }
            }
          ],
          "securityProfiles": [
            {
              "Id": "securityProfiles-1",
              "SecurityProfileName": "Mock Security Profiles 1",
              "Tags": {
                "Group": "Mock Group",
                "LOB": "Mock LOB"
              }
            },
            {
              "Id": "securityProfiles-2",
              "SecurityProfileName": "Mock Security Profiles 2",
              "Tags": {
                "Group": "Mock Group",
                "LOB": "Mock LOB"
              }
            },
            {
              "Id": "securityProfiles-3",
              "SecurityProfileName": "Mock Security Profiles 3",
              "Tags": {
                "Group": "Mock Group",
                "LOB": "Mock LOB"
              }
            },
            {
              "Id": "securityProfiles-4",
              "SecurityProfileName": "Mock Security Profiles 4",
              "Tags": {
                "Group": "Mock Group",
                "LOB": "Mock LOB"
              }
            },
            {
              "Id": "securityProfiles-5",
              "SecurityProfileName": "Mock Security Profiles 5",
              "Tags": {
                "Group": "Mock Group",
                "LOB": "Mock LOB"
              }
            },
            {
              "Id": "securityProfiles-6",
              "SecurityProfileName": "Mock Security Profiles 6",
              "Tags": {
                "Group": "Mock Group",
                "LOB": "Mock LOB"
              }
            },
            {
              "Id": "securityProfiles-7",
              "SecurityProfileName": "Mock Security Profiles 7",
              "Tags": {
                "Group": "Mock Group",
                "LOB": "Mock LOB"
              }
            },
            {
              "Id": "securityProfiles-8",
              "SecurityProfileName": "Mock Security Profiles 8",
              "Tags": {
                "Group": "Mock Group",
                "LOB": "Mock LOB"
              }
            }
          ],
          "hierarchyGroups": [
            {
              "Id": "hierarchyGroups-1",
              "Name": "Mock Hierarchy Groups 1",
              "Tags": {},
              "LevelId": "1"
            }
          ],
          // "applicationRoutingPolicies": [
          //   {
          //     "instanceId": "applicationRoutingPolicies-1",
          //     "policyId": "ENGLISH_FIRST",
          //     "policyName": "English First",
          //     "status": "active",
          //     "routingSteps": [
          //       {
          //         "routingGroupId": "routingGroups-1",
          //         "step": "1",
          //         "timeoutSeconds": "30"
          //       }
          //     ]
          //   }
          // ],
          "hoursOfOperation": [
            {
              "HoursOfOperationId": "hoursOfOperation-1",
              "Name": "Mock Hours Of Operation 1",
              "Description": "Mon-Fri 7-23:00 ET",
              "TimeZone": "ET",
              "Tags": {"LOB": "CRO"}
            }
          ],
          "contactFlows": [
            {
              "Id": "contactFlows-1",
              "Name": "Mock Contact Flow 1",
              "Type": "AGENT_HOLD",
              "Tags": {}
            }
          ],
          "quickConnects": [
            {
              "QuickConnectId": "quickConnects-1",
              "Name": "Mock Quick Connect 1",
              "QuickConnectConfig": {
                "PhoneConfig": {
                  "PhoneNumber": "1234567890"
                },
                "QuickConnectType": "PHONE"
              },
              "Tags": {"LOB": "CRO"}
            }
          ],
          "flowModules": [
            {
              "Id": "flowModules-1",
              "Name": "Mock Flow Module 1",
              "State": "active",
              "Status": "published",
              "Tags": {}
            }
          ],
          "prompts": [
            {
              "PromptId": "prompts-1",
              "Name": "Mock Prompt 1",
              "Tags": {}
            }
          ],
          "phoneNumbers": [
            {
              "Id": "phoneNumbers-1",
              "Name": "Mock Phone Number 1",
              "Number": "1234567890",
              "Tags": {}
            }
          ]
        }
      }
    }
  ],
};
  
const mockArchiveBulkStatus = {
  status: "PENDING",
  job_type: "ARCHIVE",
  result:{
    archive: {}
  }
};
  
export const mockFixtures = {
  instances: mockInstances,
  agentsByInstance: mockAgentsByInstance,
  securityProfilessByInstance: mockSecurityProfilesByInstance,
  routingProfilessByInstance: mockRoutingProfilesByInstance,
  hierarchyGroupIdsByInstance: mockHierarchyGroupIdsByInstance,
  agentActivityByInstance: mockAgentActivityByInstance,
  queuePerformanceByInstance: mockQueuePerformanceByInstance,
  queuesByInstance: mockQueuesByInstance,
  attributesByInstance: mockAttributesByInstance,
  routingGroupsByInstance: mockRoutingGroupsByInstance,
  routingPoliciesByInstance: mockRoutingPoliciesByInstance,
  routingRestrictionByInstance: mockRoutingRestrictionByInstance,
  routingSimulationsByInstance: mockRoutingSimulationsByInstance,
  routingSimulationResultById: mockRoutingSimulationResultById,
  archiveDataByInstance: mockArchiveDataByInstance,
  archiveBulkStatus: mockArchiveBulkStatus
};

export default mockFixtures;
